import { defu } from 'defu'
import routerOptions from '#build/router.options.mjs'
const sensitiveMatcher = (m,p)=>{return [];}
const foldedMatcher = sensitiveMatcher
const decodeRoutePath = function decodeRoutePath(path) {
  if (!path.includes("%"))
    return path;
  const queryIndex = path.indexOf("?"), pathname = queryIndex === -1 ? path : path.slice(0, queryIndex);
  try {
    return queryIndex === -1 ? decodeURI(pathname) : decodeURI(pathname) + path.slice(queryIndex);
  } catch {
    return path;
  }
}
const normalizePath = (path, fold) => {
  if (typeof path !== 'string') { return path }
  const decoded = decodeRoutePath(path)
  return fold ? decoded.toLowerCase() : decoded
}
export default (path) => routerOptions.sensitive
  ? defu({}, ...sensitiveMatcher('', normalizePath(path, false)).map(r => r.data).reverse())
  : defu({}, ...foldedMatcher('', normalizePath(path, true)).map(r => r.data).reverse())